import { useEffect } from 'react';

import {
	useRouteActions,
	createSingleQueryParamHook,
} from '@confluence/route-manager/entry-points/RouteState.ts';
import {
	useSetOnboardingState,
	useGetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { HAS_SEEN_AUTO_SHOW_ANALYTICS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';
import { fg } from '@confluence/feature-gating';

const useShowAnalyticsQueryParam = createSingleQueryParamHook('showAnalytics');

export const useShowAnalyticsParam = (setPopupOpen: (open: boolean) => void) => {
	const showAnalyticsParam = useShowAnalyticsQueryParam();

	const { setOnboardingState } = useSetOnboardingState();
	const { data: onboardingStateData, loading: onboardingStateLoading } = useGetOnboardingState(
		HAS_SEEN_AUTO_SHOW_ANALYTICS,
		showAnalyticsParam !== 'true' || !fg('cc_first_ever_view_email_analytics_kill_switch'),
	);

	const { setQueryParams } = useRouteActions();

	useEffect(() => {
		if (!fg('cc_first_ever_view_email_analytics_kill_switch') || onboardingStateLoading) {
			return;
		}

		if (showAnalyticsParam === 'true') {
			setQueryParams({ showAnalytics: undefined }, true);

			const { hasSeenAutoShowAnalytics } = deserializeState(onboardingStateData);

			if (!hasSeenAutoShowAnalytics) {
				setPopupOpen(true);
				setOnboardingState({
					key: HAS_SEEN_AUTO_SHOW_ANALYTICS,
					value: 'true',
				});
			}
		}
	}, [
		showAnalyticsParam,
		setQueryParams,
		onboardingStateLoading,
		onboardingStateData,
		setOnboardingState,
		setPopupOpen,
	]);
};
